module.exports = __webpack_public_path__ + "img/angel-vignette.a80d7236.jpg";